// A group of colors that helps when there's need to draw
// things in different colors programmatically
export default [
  '#4cc9f0',
  '#4895ef',
  '#4361ee',
  '#3f37c9',
  '#3a0ca3',
  '#480ca8',
  '#560bad',
  '#7209b7',
  '#b5179e',
  '#f72585',
]
